import { useMemo } from 'react';
import { Approver } from '../types';

export const useFilterApprovers = (approvers: readonly Approver[]) => {
  const validQualityApprovers = useMemo(
    () =>
      approvers.filter((user) => {
        return user.user_type === 'quality';
      }),
    [approvers],
  );

  const validOtherApprovers = useMemo(
    () =>
      approvers.filter((user) => {
        return user.user_type === 'normal';
      }),
    [approvers],
  );

  const validUsersMap = useMemo(() => {
    return { quality: validQualityApprovers, other: validOtherApprovers };
  }, [validOtherApprovers, validQualityApprovers]);

  return (approvalType: 'quality' | 'other') => validUsersMap[approvalType];
};
